module.exports = __webpack_public_path__ + "static/media/herbie_fair.868591f6.png";